import { render } from "./VerifyAccountNotice.vue?vue&type=template&id=1cbf94ba&ts=true"
import script from "./VerifyAccountNotice.vue?vue&type=script&lang=ts"
export * from "./VerifyAccountNotice.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__